<template>
  <section>
    <qx-tab :tabs="tabs" v-model="activeTab" />
    <!-- 公司自有车 -->
    <Edit v-show="activeTab === '1'" carUserType="1" />
    <!-- 业务招商车 -->
    <Edit v-show="activeTab === '2'" carUserType="2" />
    <!-- 临时外调车 -->
    <Edit v-show="activeTab === '3'" carUserType="3" />
    <!-- 外来挂靠车 -->
    <Edit v-show="activeTab === '4'" carUserType="4" />
  </section>
</template>

<script>
import Edit from './edit/edit';
export default {
  components: {
    Edit,
  },
  data () {
    return {
      activeTab: '1',
      tabs: [
        {
          label: '公司自有车',
          value: '1',
        },
        {
          label: '临时外调车',
          value: '3',
        },
        {
          label: '业务招商车',
          value: '2',
        },
        {
          label: '外来挂靠车',
          value: '4',
        },
      ],
    };
  },
};
</script>

<style>
</style>
